import React from 'react';
import customFetch from '../utils/customFetch';
import { redirect, useLoaderData } from 'react-router-dom';
import { Header } from '../components';

export const loader = async ({ request }) => {
  const url = new URL(request.url);
  const verificationToken = url.searchParams.get('token');
  const email = url.searchParams.get('email');

  if (!email || !verificationToken) {
    return redirect('/login');
  }

  try {
    const { data } = await customFetch.post('/auth/verify-email', {
      verificationToken,
      email,
    });
    return { data };
  } catch (error) {
    const err = { error };
    const data = { data: { msg: err.error.message } };
    return data;
  }
};

const VerifyEmail = () => {
  const { data } = useLoaderData();
  return (
    <>
      <Header />
      <div className="h-full bg-gray-50" style={{ height: '100vh' }}>
        <div className="h-full">
          <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                {data?.msg}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
